import {
  createContext,
  Dispatch,
  PropsWithChildren,
  RefObject,
  SetStateAction,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react"
import { OrderStatusEnum } from "src/features/shared-module/constants"
import { useAppDispatch, useAppSelector } from "../hooks"
import {
  setExpandableSections,
  setScrollingDetail,
} from "../slices/dashboard.slice"

interface OrderContextType {
  orderDetailRefs: Record<number, RefObject<HTMLDivElement | null>>
  isFilterExpanded: boolean
  setIsFilterExpanded: Dispatch<SetStateAction<boolean>>
}

const OrderContext = createContext<OrderContextType>({
  orderDetailRefs: {},
  isFilterExpanded: false,
  setIsFilterExpanded: () => {},
})

export const useOrderContex = () => useContext(OrderContext)

export const OrderContextProvider = ({ children }: PropsWithChildren) => {
  const orderDetailRefs = useRef<
    Record<number, RefObject<HTMLDivElement | null>>
  >({})
  const [isFilterExpanded, setIsFilterExpanded] = useState<boolean>(false)

  const dispatch = useAppDispatch()

  const scrollingOrder = useAppSelector(
    (state) => state.dashboard.scrollingDetail,
  )
  const expandableSections = useAppSelector(
    (state) => state.dashboard.expandableSections,
  )

  useEffect(() => {
    if (!scrollingOrder) return

    const scrollToOrderId = scrollingOrder.id
    if (
      scrollingOrder.state === OrderStatusEnum.READY_FOR_HAULAGE &&
      !expandableSections.order
    ) {
      dispatch(setExpandableSections("order"))
    }
    setIsFilterExpanded(false)
    setTimeout(() => {
      if (orderDetailRefs.current?.[scrollToOrderId]?.current) {
        orderDetailRefs.current?.[scrollToOrderId]?.current.scrollIntoView({
          behavior: "smooth",
        })
        dispatch(setScrollingDetail(null))
      }
    }, 1500)
  }, [scrollingOrder, dispatch, expandableSections])

  return (
    <OrderContext.Provider
      value={{
        orderDetailRefs: orderDetailRefs.current,
        isFilterExpanded,
        setIsFilterExpanded,
      }}
    >
      {children}
    </OrderContext.Provider>
  )
}
